module.exports = __webpack_public_path__ + "static/media/PictoScheduleActive.bbcff03f.svg";